import React from 'react';
import SkipLink from '@domain-group/fe-co-skip-link';
import { ContactHeadWithQuery, ErrorBoundary } from '..';
import AgentProfile, { AgentProfileProps } from './agent-profile';
import AgentProfile2026 from './agent-profile-2026';
import { skipLinkName } from '../../helper/accessibility-utils';

export interface AgentProfilePageProps extends AgentProfileProps {
  isNewProfilePage?: boolean;
  user?: {
    userId: string;
    sessionId: string;
    disableUserTracking: boolean;
    userName: string;
    givenName: string;
    familyName: string;
    postcode: string;
    userToken: string;
    emailHash: string;
    ipHash: string;
  };
}

/**
 * Shared shell for the agent profile page. The only difference between the
 * legacy and 2026 variants is `isNewProfilePage`. The head/meta tags live
 * here rather than in each variant so both get title, canonical, schema and
 * digital-data tags - the SSR prepass in getAgentProfilePageServerSideProps
 * always warms the cache through the legacy AgentProfile tree, which is
 * discarded rather than rendered, so a variant can't rely on rendering its
 * own copy during that pass.
 */
const AgentProfilePage = ({
  isNewProfilePage = false,
  ...props
}: AgentProfilePageProps): JSX.Element => {
  const Profile = isNewProfilePage ? AgentProfile2026 : AgentProfile;

  return (
    <ErrorBoundary>
      <>
        <ContactHeadWithQuery
          contactId={props.contactId}
          user={props.user}
          imageFormat={props.imageFormat}
        />
        <SkipLink anchorName={skipLinkName} />
        <Profile {...props} />
      </>
    </ErrorBoundary>
  );
};

export default AgentProfilePage;
